// extracted by mini-css-extract-plugin
module.exports = {"main_container":"NotFound_main_container__zJ_ei","image_container":"NotFound_image_container__2ZZmX"};